var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6.50001C11.5 5.76401 10.884 5.16667 10.125 5.16667H9.4375V3.83334C9.4375 1.99267 7.89819 0.5 6.00001 0.5C4.10181 0.5 2.5625 1.99267 2.5625 3.83334V5.16667H1.875C1.11601 5.16667 0.5 5.76401 0.5 6.50001V13.1667C0.5 13.9027 1.11601 14.5 1.875 14.5H10.125C10.884 14.5 11.5 13.9027 11.5 13.1667V6.50001ZM3.9375 3.83438C3.9375 2.72981 4.86088 1.83438 6 1.83438C7.13911 1.83438 8.06249 2.72981 8.06249 3.83438V5.16771H3.9375V3.83438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLock);
export default __webpack_public_path__ + "static/media/WhiteLock.52e06d8b990686da43742e85e35b3c71.svg";
export { ForwardRef as ReactComponent };